module.exports = __webpack_public_path__ + "img/report-7.e6c2228e.jpg";